export const TMP_ACTIONS = {
  SET_TMP_MARKER: "SET_TMP_MARKER",
  TOGGLE_SHARE_DIALOG: "TOGGLE_SHARE_DIALOG",
};
